var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('v-col',{attrs:{"lg":"4","md":"4","xl":"4"}},[_c('div',{staticClass:"py-4"},[_c('current-user-short-block')],1)]):_vm._e(),_c('v-col',{staticClass:"px-sm-only-0 px-xs-0",attrs:{"lg":"8","md":"8","xl":"8"}},[_c('router-view',{staticClass:"mt-4"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }